<div class="p500-ui-form-field">
  <p500-ui-select-field [formControl]="control" [data]="data" [readonly]="readonly" [label]="label"> </p500-ui-select-field>
  <div *ngIf="control.getError('customValidate')" class="err-msg-tooltip">
    {{ control.getError('customValidate') }}
  </div>
</div>
